import {map} from 'rxjs/operators';
import {ofType} from 'redux-observable';

import {FETCH_ATTRIBUTES_SUCCESS} from '../attributes/attributes.action';
import {SECURITY_GROUPS_RETRIEVED} from '../security/security.action';
import * as TableColumns from './table-columns.action';
import * as UserActions from '../user/user.actions';

export const mapToSetAttributes = action$ =>
  action$.pipe(ofType(FETCH_ATTRIBUTES_SUCCESS), map(action => TableColumns.setAttributes(action.payload)));

export const mapToSetSecurityGroups = action$ =>
  action$.pipe(ofType(SECURITY_GROUPS_RETRIEVED), map(action => TableColumns.setSecurityGroups(action.payload)));

export const mapToSetSetColumnVisibility = (action$, store$) =>
  action$.pipe(ofType(UserActions.REQUEST_USER_SUCCESS), map(() => TableColumns.setColumnVisiblity(store$.value.user)));
